import {
  signOut as _signOut,
  OAuthProvider as _OAuthProvider,
  signInWithPopup as _signInWithPopup,
  sendPasswordResetEmail as _sendPasswordResetEmail,
  signInWithEmailAndPassword as _signInWithEmailAndPassword,
} from 'firebase/auth';

import { AUTH } from 'src/lib/firebase';
import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

export type SignInParams = {
  email: string;
  password: string;
};

export type SignUpParams = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
};

export type ForgotPasswordParams = {
  email: string;
};

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async ({ email, password }: SignInParams): Promise<void> => {
  try {
    await _signInWithEmailAndPassword(AUTH, email, password);

    const user = AUTH.currentUser;

    if (!user?.emailVerified) {
      throw new Error('Email not verified!');
    }
  } catch (error) {
    console.error('Error during sign in with password:', error);
    throw error;
  }
};

export const signInWithMicrosoft = async (): Promise<void> => {
  const provider = new _OAuthProvider('microsoft.com');
  provider.addScope('openid');
  provider.addScope('email');
  provider.addScope('profile');

  // Pin to the Bayern-Fass Azure AD tenant when configured; otherwise fall back
  // to the default `common` endpoint. `prompt: 'select_account'` ensures users
  // can switch between accounts instead of being silently logged in with a
  // cached (and possibly wrong) Microsoft session.
  const {tenantId} = CONFIG.azure;
  provider.setCustomParameters(
    tenantId
      ? { tenant: tenantId, prompt: 'select_account' }
      : { prompt: 'select_account' }
  );

  await _signInWithPopup(AUTH, provider);
};

/** **************************************
 * Sign up
 *************************************** */
export const signUp = async (_params: SignUpParams): Promise<void> => {
  throw new Error('Sign up is disabled.');
};

/** **************************************
 * Sign out
 *************************************** */
export const signOut = async (): Promise<void> => {
  await _signOut(AUTH);
};

/** **************************************
 * Reset password
 *************************************** */
export const sendPasswordResetEmail = async ({ email }: ForgotPasswordParams): Promise<void> => {
  await _sendPasswordResetEmail(AUTH, email);
};
